
@if (initialized) {

  <div class="grid surface-0 mt-5">
    <div class="xl:col-5 lg:col-7 col-12 text-center">
      <p-calendar
        class="max-w-full"
        styleClass="w-full"
        [(ngModel)]="selectedDate"
        (onMonthChange)="handleMonthChange($event)"
        (onSelect)="handleSelectDate($event)"
        view="date"
        dateFormat="yy-mm-dd"
        [minDate]="today"
        [inline]="true"
        [showWeek]="false"
        [firstDayOfWeek]="1"
        [disabledDays]="[0,6]"
      >
        <ng-template pTemplate="date" let-date>
          <span [class]="isDayFree(date) ? 'free-day' : ''">{{ date.day }}</span>
        </ng-template>

      </p-calendar>
    </div>

    <div class="xl:col-7 lg:col-5 col-12">
      <div class="flex justify-content-center w-full" *ngIf="busy">
        <p-progressSpinner styleClass="w-4rem h-4rem"></p-progressSpinner>
      </div>
      @if (timeSlots) {
        <div class="border-1 border-300 border-round-lg h-full p-3">
          <div class="mb-5 flex flex-column">
            <span class="text-color text-3xl font-semibold px-2">{{selectedDate | date: 'MMMM d, y'}}</span>
            <!--            <p-message *ngIf="timeSlots.uiMessageEmpty" [text]="timeSlots.uiMessageEmpty"-->
            <!--                       [ngStyle]="{'word-break': 'break-word'}"></p-message>-->
            What time works best?
          </div>

          @if (timeSlots) {
            <div class="grid">
              @for (item of timeSlots; track item.id) {
                <div class="xl:col-6 col-12">
                  <div
                    [ngClass]="selectedPeriod?.id == item.id ? 'text-primary bg-primary-50 border-primary-500' : 'surface-border text-color'"
                    class="border-round-lg p-3 mb-2 border-1 cursor-pointer"
                    (click)="onSelect(item)">
                    <div class="flex justify-content-between">
                      <span>  {{ item.timeSlot?.start | date: 'HH:mm' }}</span>
                      <span>
                      @if (item.timeSlot.duration) {
                        {{ item.timeSlot.duration | periodDurationPipe }}
                      }
                      </span>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }


    </div>
  </div>


}
